import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import ZoomControl from '../components/ZoomControl'
import MapActions from '../redux/mapRedux'

class ZoomControlContainer extends PureComponent {
  render () {
    const { actions } = this.props
    return (
      <ZoomControl handleZoomIn={actions.zoomIn} handleZoomOut={actions.zoomOut} />
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      zoomIn: () => dispatch(MapActions.zoomIn()),
      zoomOut: () => dispatch(MapActions.zoomOut())
    }
  }
}

export default connect(null, mapDispatchToProps)(ZoomControlContainer)



// WEBPACK FOOTER //
// ./src/containers/ZoomControlContainer.js